import { React, useState, useEffect } from 'react';
import PageHeader from 'utility/PageHeader';
import PageBody from 'utility/PageBody';
import { Button, Form, Input, Row, Col, Table, Modal, Typography } from 'antd';
import {
  SearchOutlined,
  PlusOutlined,
  DeleteOutlined,
  EditOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';
import { HttpHandler } from '../../shared/httpHandler';
import PropTypes from 'prop-types';
const { Paragraph } = Typography;
const httpHandler = new HttpHandler();
// 父組件
const Project = () => {
  const [searchForm] = Form.useForm();
  const [modalForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });
    updateData(pagination);
  };

  const updateData = (pagination = tableParams.pagination) => {
    const { projectName } = searchForm.getFieldsValue();
    const { current, pageSize } = pagination;
    setLoading(true);
    httpHandler
      .get(
        `/line-official-mgmt/project/list?project_name=${projectName}&page=${current}&page_size=${pageSize}&is_all=false`
      )
      .then((response) => {
        if (response.success) {
          setTableData(response.data);
          setTableParams({
            ...tableParams,
            pagination: {
              ...pagination,
              total: response.total,
            },
          });
        } else {
          window.antdNotify('錯誤', response.data.message, 'fail');
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDelete = (id) => {
    Modal.confirm({
      maskClosable: true, // 點擊蒙層是否允許關閉
      title: '確定刪除？',
      icon: <QuestionCircleOutlined />,
      footer: (_, { OkBtn, CancelBtn }) => (
        <>
          <CancelBtn />
          <OkBtn loading={deleteLoading} />
        </>
      ),
      okText: '確定',
      cancelText: '取消',
      onOk: async () => {
        setDeleteLoading(true);
        return httpHandler
          .delete(`/line-official-mgmt/project/${id}`)
          .then((response) => {
            if (response.success) {
              window.antdNotify('成功', '刪除成功', 'success');
              searchProject();
            } else {
              window.antdNotify('錯誤', response.data.message, 'fail');
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            setDeleteLoading(false);
          });
      },
    });
  };

  const searchProject = async () => {
    setTableParams({
      ...tableParams,
      pagination: {
        current: 1,
        pageSize: 10,
      },
    });
    updateData({
      current: 1,
      pageSize: 10,
    });
  };

  useEffect(() => {
    // 預設表單值
    searchForm.setFieldsValue({
      projectName: '',
    });
    // 進入畫面時執行一次搜尋
    searchProject();
  }, []);
  // 搜尋組件
  const SearchBar = () => {
    return (
      <>
        <Form form={searchForm} name="searchForm" onFinish={searchProject}>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item label="專案名稱" name="projectName">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={16} className="button-group">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  setIsNew(true);
                  setIsModalVisible(true);
                }}
                className="button button--register">
                新增
              </Button>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                htmlType="submit"
                className="button button--search">
                搜尋
              </Button>
            </Col>
          </Row>
        </Form>
      </>
    );
  };
  // 表格組件
  const DataTable = () => {
    const [isReadMoreModalVisible, setIsReadMoreModalVisible] = useState(false);
    const [currentText, setCurrentText] = useState('');
    const readMore = (text) => {
      const maxLength = 10; // 最大顯示的字元數
      if (text.length > maxLength) {
        return (
          <span>
            {text.substring(0, maxLength)}...
            <a
              onClick={() => {
                setCurrentText(text);
                setIsReadMoreModalVisible(true);
              }}>
              閱讀更多
            </a>
          </span>
        );
      }
      return text;
    };
    let columns = [
      {
        title: 'id',
        dataIndex: 'id',
        hidden: true,
      },
      {
        title: '專案名稱',
        dataIndex: 'name',
      },
      {
        title: '操作',
        dataIndex: '',
        render: (text, record, index) => {
          return (
            <>
              <Button
                icon={<EditOutlined />}
                type="primary"
                className="button--edit"
                style={{ marginRight: 16 }}
                onClick={() => {
                  setIsModalVisible(true);
                  setIsNew(false);
                  modalForm.setFieldsValue({
                    id: record.id,
                    projectName: record.name,
                    projectUrl: record.url,
                    content: record.content,
                    brand: record.brand,
                    memo: record.memo,
                  });
                }}>
                修改
              </Button>
              <Button
                icon={<DeleteOutlined />}
                type="primary"
                className="button--delete"
                onClick={() => {
                  handleDelete(record.id);
                }}>
                刪除
              </Button>
            </>
          );
        },
      },
      {
        title: '專案網址',
        dataIndex: 'url',
        render: (url) => {
          if (url)
            return (
              <a href={url} target="_blank" rel="noopener noreferrer">
                活動網址
              </a>
            );
          return '';
        },
      },
      {
        title: '綁定品牌',
        dataIndex: 'brand',
      },
      {
        title: 'Line文字訊息內容',
        dataIndex: 'content',
        render: (text) => {
          if (text) {
            return readMore(text);
          }
        },
      },
      {
        title: '備註',
        dataIndex: 'memo',
        render: (text) => {
          if (text) {
            return readMore(text);
          }
        },
      },
      {
        title: '修改時間',
        dataIndex: 'update_time',
      },
      {
        title: '修改人員',
        dataIndex: 'update_user',
      },
      {
        title: '建立時間',
        dataIndex: 'create_time',
      },
      {
        title: '建立人員',
        dataIndex: 'create_user',
      },
    ].filter((item) => !item.hidden);

    return (
      <>
        <Table
          columns={columns}
          rowKey={(row) => row.id}
          dataSource={tableData}
          pagination={tableParams.pagination}
          loading={loading}
          bordered="true"
          scroll={{ x: 'max-content' }}
          onChange={handleTableChange}
        />
        <Modal
          title="完整內容"
          open={isReadMoreModalVisible}
          onOk={() => setIsReadMoreModalVisible(false)}
          onCancel={() => setIsReadMoreModalVisible(false)}>
          <Typography>
            <Paragraph>
              <pre>{currentText}</pre>
            </Paragraph>
          </Typography>
        </Modal>
      </>
    );
  };

  const section = [
    {
      hasTitle: false,
      title: 'Search',
      children: <SearchBar />,
    },
    {
      hasTitle: false,
      title: 'Data',
      children: <DataTable />,
    },
    {
      hasTitle: false,
      title: 'Modal',
      children: (
        <ProjectModal
          searchProject={searchProject}
          isModalVisible={isModalVisible}
          setIsModalVisible={setIsModalVisible}
          modalForm={modalForm}
          isNew={isNew}
        />
      ),
    },
  ];

  return (
    <div>
      <PageHeader functionName={'project'}></PageHeader>
      <PageBody section={section}></PageBody>
    </div>
  );
};
// 共用的Modal
const ProjectModal = (props) => {
  const { searchProject, isModalVisible, setIsModalVisible, modalForm, isNew } =
    props;
  const [loading, setLoading] = useState(false);

  const handleModalSubmit = () => {
    modalForm.validateFields().then(async (values) => {
      const confirmed = await window.antdConfirm(
        `確定${isNew ? '新增' : '修改'}專案嗎？`
      );
      if (!confirmed) return;
      setLoading(true);
      // 根據isNew判斷是新增還是修改
      let requestPromise;
      const msg = isNew ? '新增成功' : '修改成功';
      if (isNew === true) {
        requestPromise = httpHandler.post('/line-official-mgmt/project', {
          name: values.projectName,
          brand: values.brand,
          url: values.projectUrl,
          content: values.content,
          memo: values.memo,
        });
      } else {
        requestPromise = httpHandler.put(
          `/line-official-mgmt/project/${values.id}`,
          {
            name: values.projectName,
            brand: values.brand,
            url: values.projectUrl,
            content: values.content,
            memo: values.memo,
          }
        );
      }
      requestPromise.then((response) => {
        if (response.success) {
          window.antdNotify('成功', msg, 'success');
          setIsModalVisible(false);
          searchProject();
          modalForm.resetFields();
          setLoading(false);
        } else {
          setLoading(false);
          window.antdNotify('錯誤', response.data.message, 'fail');
        }
      });
    });
  };
  const handleModalCancel = () => {
    modalForm.resetFields();
    setIsModalVisible(false);
  };
  return (
    <Modal
      title={isNew ? '新增專案' : '修改專案'}
      open={isModalVisible}
      onCancel={handleModalCancel}
      footer={[
        <Button key="back" onClick={handleModalCancel}>
          取消
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleModalSubmit}
          loading={loading}>
          確定
        </Button>,
      ]}
      okButtonProps={{ loading: loading }}>
      <ModalForm modalForm={modalForm} />
    </Modal>
  );
};
// 共用Modal專用的Form(新增、修改共用)
const ModalForm = (props) => {
  const { modalForm } = props;
  return (
    <Form form={modalForm}>
      <Form.Item name="id" hidden>
        <Input />
      </Form.Item>
      <Form.Item
        label="專案名稱"
        name="projectName"
        rules={[{ required: true, message: '請輸入專案名稱!' }]}>
        <Input />
      </Form.Item>
      <Form.Item
        label="綁定品牌"
        name="brand"
        rules={[{ required: true, message: '請輸入綁定品牌!' }]}>
        <Input />
      </Form.Item>
      <Form.Item label="專案網址" name="projectUrl">
        <Input />
      </Form.Item>
      <Form.Item label="Line文字訊息內容" name="content">
        <Input.TextArea />
      </Form.Item>
      <Form.Item label="備註" name="memo">
        <Input.TextArea />
      </Form.Item>
    </Form>
  );
};

// 驗證props
ProjectModal.propTypes = {
  searchProject: PropTypes.func,
  isModalVisible: PropTypes.bool,
  setIsModalVisible: PropTypes.func,
  modalForm: PropTypes.object,
};
ModalForm.propTypes = {
  modalForm: PropTypes.object,
};
export default Project;
